module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-09-8a565a8fff6401ff033b269e3973d1f0.svg";